import { render, staticRenderFns } from "./TextSwitcher.vue?vue&type=template&id=65edb502&"
import script from "./TextSwitcher.vue?vue&type=script&lang=js&"
export * from "./TextSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports